/**
 * Thin fetch wrapper for raftor_webhq.catalog.api.get_filter_facets.
 *
 * Mirrors adapters/webshop_source.js's settle-guaranteed call() pattern -
 * a facet fetch that never resolves would leave the filter panel blank
 * forever instead of just missing counts.
 */

const METHOD = 'raftor_webhq.catalog.api.get_filter_facets';

export function fetchFacets({ itemGroup, queryArgs } = {}) {
	return new Promise((resolve) => {
		let settled = false;
		const done = (value) => {
			if (settled) return;
			settled = true;
			resolve(value || {});
		};

		if (typeof frappe === 'undefined' || !frappe.call) {
			done({});
			return;
		}

		let req;
		try {
			req = frappe.call({
				method: METHOD,
				args: { item_group: itemGroup || null, query_args: JSON.stringify(queryArgs || {}) },
				callback: (r) => done(r && r.message),
				error: () => done({}),
			});
		} catch (err) {
			done({});
			return;
		}

		if (req && typeof req.always === 'function') {
			req.always(() => setTimeout(() => done({}), 0));
		} else {
			setTimeout(() => done({}), 15000);
		}
	});
}
